import clsx from 'clsx';
import styles from './KioskLoadingIcon.module.scss';

type KioskLoadingIconProps = {
    className?: string;
};

const KioskLoadingIcon = ({ className }: KioskLoadingIconProps) => {
    return (
        <div className={clsx(styles.container, className)} aria-hidden="true">
            <svg className={styles.background} fill="none" preserveAspectRatio="xMidYMid meet" viewBox="0 0 215 249">
                <g>
                    <g>
                        <path
                            clipRule="evenodd"
                            d="M0 186.75L33.7493 167.201L107.5 209.902L107.5 249L0 186.75Z"
                            fill="#131313"
                            fillRule="evenodd"
                        />
                        <path
                            clipRule="evenodd"
                            d="M0.00168851 62.3069L33.7564 81.8464L33.7601 167.255L0 186.804L0.00168851 62.3069Z"
                            fill="#131313"
                            fillRule="evenodd"
                        />
                    </g>
                    <g>
                        <path
                            clipRule="evenodd"
                            d="M215 186.75L181.251 167.201L107.5 209.903L107.5 249L215 186.75Z"
                            fill="#222222"
                            fillRule="evenodd"
                        />
                        <path
                            clipRule="evenodd"
                            d="M214.998 62.307L181.244 81.8465L181.24 167.255L215 186.804L214.998 62.307Z"
                            fill="#222222"
                            fillRule="evenodd"
                        />
                    </g>
                    <g>
                        <path d="M0 62.2501L33.7493 81.799L107.5 39.0978V0L0 62.2501Z" fill="#333333" />
                        <path d="M215 62.3068L181.251 81.8558L107.5 39.1545V0.0567446L215 62.3068Z" fill="#333333" />
                    </g>
                    <path d="M107.501 209.903L181.251 167.201L107.501 130.118L33.75 167.201L107.501 209.903Z" fill="#090909" />
                    <path
                        clipRule="evenodd"
                        d="M33.7598 81.7991V167.201L107.51 130.118L107.51 39.0979L33.7598 81.7991Z"
                        fill="#1A1A1A"
                        fillRule="evenodd"
                    />
                    <path d="M181.251 167.201L107.5 130.118V39.0979L181.251 81.7991V167.201Z" fill="#131313" />
                </g>
            </svg>
            <div className={styles.dots}>
                <svg fill="none" viewBox="0 0 94 18">
                    <circle className={clsx(styles.dot, styles.dot1)} cx="9" cy="9" r="8" fill="white" />
                    <circle className={clsx(styles.dot, styles.dot2)} cx="47" cy="9" r="8" fill="white" />
                    <circle className={clsx(styles.dot, styles.dot3)} cx="85" cy="9" r="8" fill="white" />
                </svg>
            </div>
        </div>
    );
};

export default KioskLoadingIcon;
